"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getQueryParams = function getQueryParams(query) {
  return query && Qs.stringify(query) ? "?" + Qs.stringify(query) : "";
};

var ApiClient = function () {
  function ApiClient(SERVER_NX_URL, rootScope) {
    var _this = this;

    _classCallCheck(this, ApiClient);

    this.log = debug("api:client");

    this.rootScope = rootScope;

    this.token = sessionStorage.getItem("lvrAccessToken") || null; // Survives page refresh; cleared on tab close

    this.baseUrl = SERVER_NX_URL;
    this.headers = { "Content-Type": "application/json" };

    this.handleErrors = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
        var json, code, _json, _code, _json2, error;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(response.status == 401)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 3;
                return response.json();

              case 3:
                json = _context.sent;
                code = "";

                if (json && json.error && json.error.code) {
                  code = json.error.code;
                }
                _this.rootScope.$broadcast("auth_not_authenticated", code);
                _context.next = 32;
                break;

              case 9:
                if (!(response.status == 403)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return response.json();

              case 12:
                _json = _context.sent;
                _code = "";

                if (_json && _json.error && _json.error.code) {
                  _code = _json.error.code;
                }
                _this.rootScope.$broadcast("auth_forbidden", _code);
                _context.next = 32;
                break;

              case 18:
                if (response.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 21;
                return response.json();

              case 21:
                _json2 = _context.sent;
                error = response.statusText;

                if (_json2 && _json2.error && _json2.error.message) {
                  error = _json2.error.message;
                }
                throw Error(response.status + " (" + error + ")");

              case 27:
                if (!(response.status == 204)) {
                  _context.next = 31;
                  break;
                }

                return _context.abrupt("return", {});

              case 31:
                return _context.abrupt("return", response.json());

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }

  _createClass(ApiClient, [{
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.token = token;
      if (token) {
        sessionStorage.setItem("lvrAccessToken", token);
      } else {
        sessionStorage.removeItem("lvrAccessToken");
      }
    }
  }, {
    key: "getToken",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var refreshFromCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var response, json;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.token || refreshFromCookie)) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return fetch(this.baseUrl + "/auth/token", {
                  credentials: "include",
                  headers: this.headers
                });

              case 4:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return response.json();

              case 8:
                json = _context2.sent;

                if (json && json.id) {
                  this.setToken(json.id);
                }

              case 10:
                _context2.next = 14;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);

              case 14:
                return _context2.abrupt("return", this.token);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12]]);
      }));

      function getToken() {
        return _ref2.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "login",
    value: function login(credential) {
      var _this2 = this;

      return new Promise(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var data;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(credential && credential.email && credential.password)) {
                    _context4.next = 5;
                    break;
                  }

                  data = {
                    email: credential.email,
                    password: credential.password
                  };
                  return _context4.abrupt("return", fetch(_this2.baseUrl + "/users/login?include=user", {
                    method: "POST",
                    credentials: "include",
                    body: angular.toJson(data),
                    headers: _this2.headers
                  }).then(function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return _this2.handleErrors(response);

                            case 2:
                              return _context3.abrupt("return", _context3.sent);

                            case 3:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this2);
                    }));

                    return function (_x5) {
                      return _ref4.apply(this, arguments);
                    };
                  }()).then(function (result) {
                    _this2.setToken(result.id);

                    resolve(result);
                  }).catch(function (error) {
                    _this2.rootScope.$broadcast("other_error", error);
                    reject(error);
                  }));

                case 5:
                  reject("bad crendential object");

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this2);
        }));

        return function (_x3, _x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getModel",
    value: function getModel(name) {
      return new ApiModel(name, this);
    }
  }]);

  return ApiClient;
}();

var ApiModel = function ApiModel(name, tokenClient) {
  var _this3 = this;

  _classCallCheck(this, ApiModel);

  this.log = debug("api:model");
  this.baseUrl = tokenClient.getBaseUrl();

  this.name = name;

  this.handleErrors = tokenClient.handleErrors;
  this.rootScope = tokenClient.rootScope;

  this._authHeaders = function () {
    var headers = { "Content-Type": "application/json" };
    var token = tokenClient.token;
    if (token) headers["Authorization"] = "Bearer " + token;
    return headers;
  };

  this.get = function (path, params) {
    var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "json";

    return new Promise(function (resolve, reject) {
      var query = "";
      if (params) {
        var esc = encodeURIComponent;
        query = "?" + Object.keys(params).map(function (k) {
          return esc(k) + "=" + esc(params[k]);
        }).join("&");
      }

      var url = _this3.baseUrl + "/" + path;

      fetch(url + query, {
        method: "GET",
        credentials: "include",
        headers: _this3._authHeaders()
      }).then(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
          var data;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (response.ok) {
                    _context5.next = 6;
                    break;
                  }

                  _context5.next = 3;
                  return response.json();

                case 3:
                  data = _context5.sent;

                  Notiflix.Notify.failure(data ? data.message || data.error : "Erreur inconnue");
                  throw new Error("Network response was not ok");

                case 6:
                  if (!(responseType === "blob")) {
                    _context5.next = 8;
                    break;
                  }

                  return _context5.abrupt("return", response.blob());

                case 8:
                  return _context5.abrupt("return", response.json());

                case 9:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, _this3);
        }));

        return function (_x7) {
          return _ref5.apply(this, arguments);
        };
      }()).then(function (data) {
        return resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  this.post = function (path, body) {
    return new Promise(function (resolve, reject) {
      var url = _this3.baseUrl + "/" + path;

      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: _this3._authHeaders(),
        body: JSON.stringify(body)
      }).then(function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(response) {
          var data, ct;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (response.ok) {
                    _context6.next = 6;
                    break;
                  }

                  _context6.next = 3;
                  return response.json();

                case 3:
                  data = _context6.sent;

                  Notiflix.Notify.failure(data ? data.message || data.error : "Erreur inconnue");
                  throw new Error("Network response was not ok");

                case 6:
                  ct = response.headers.get("content-type") || "";

                  if (!ct.includes("application/json")) {
                    _context6.next = 9;
                    break;
                  }

                  return _context6.abrupt("return", response.json());

                case 9:
                  if (!ct.includes("text/")) {
                    _context6.next = 11;
                    break;
                  }

                  return _context6.abrupt("return", response.text());

                case 11:
                  if (!ct.includes("application/octet-stream")) {
                    _context6.next = 13;
                    break;
                  }

                  return _context6.abrupt("return", response.blob());

                case 13:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, _this3);
        }));

        return function (_x8) {
          return _ref6.apply(this, arguments);
        };
      }()).then(function (data) {
        return resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  this.put = function (path, body) {
    return new Promise(function (resolve, reject) {
      var url = _this3.baseUrl + "/" + path;

      fetch(url, {
        method: "PUT",
        credentials: "include",
        headers: _this3._authHeaders(),
        body: JSON.stringify(body)
      }).then(function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(response) {
          var data;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (response.ok) {
                    _context7.next = 6;
                    break;
                  }

                  _context7.next = 3;
                  return response.json();

                case 3:
                  data = _context7.sent;

                  Notiflix.Notify.failure(data ? data.message || data.error : "Erreur inconnue");
                  throw new Error("Network response was not ok");

                case 6:
                  return _context7.abrupt("return", response.json());

                case 7:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, _this3);
        }));

        return function (_x9) {
          return _ref7.apply(this, arguments);
        };
      }()).then(function (data) {
        return resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  this.patch = function (path, body) {
    return new Promise(function (resolve, reject) {
      var url = _this3.baseUrl + "/" + path;

      fetch(url, {
        method: "PATCH",
        credentials: "include",
        headers: _this3._authHeaders(),
        body: JSON.stringify(body)
      }).then(function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(response) {
          var data;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (response.ok) {
                    _context8.next = 6;
                    break;
                  }

                  _context8.next = 3;
                  return response.json();

                case 3:
                  data = _context8.sent;

                  Notiflix.Notify.failure(data ? data.message || data.error : "Erreur inconnue");
                  throw new Error("Network response was not ok");

                case 6:
                  return _context8.abrupt("return", response.json());

                case 7:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, _this3);
        }));

        return function (_x10) {
          return _ref8.apply(this, arguments);
        };
      }()).then(function (data) {
        return resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  this.del = function (path) {
    return new Promise(function (resolve, reject) {
      var url = _this3.baseUrl + "/" + path;

      fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: _this3._authHeaders()
      }).then(function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(response) {
          var data;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (response.ok) {
                    _context9.next = 6;
                    break;
                  }

                  _context9.next = 3;
                  return response.json();

                case 3:
                  data = _context9.sent;

                  Notiflix.Notify.failure(data ? data.message || data.error : "Erreur inconnue");
                  throw new Error("Network response was not ok");

                case 6:
                  return _context9.abrupt("return", response.text());

                case 7:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, _this3);
        }));

        return function (_x11) {
          return _ref9.apply(this, arguments);
        };
      }()).then(function (data) {
        return resolve(data);
      }).catch(function (error) {
        return reject(error);
      });
    });
  };

  this.findById = function (data) {
    return _this3.findOne({
      filter: {
        where: { _id: data._id.replace("$", "") },
        fields: data.fields || {}
      }
    });
  };

  this.updateAttributesById = function (_id, data) {
    return _this3.patch(_this3.name + "/updateOneById", {
      id: _id,
      vals: data
    });
  };

  this.find = function (filter) {
    return _this3.post(_this3.name + "/find", {
      conditions: filter.filter.where || {},
      projection: filter.filter.fields || {},
      options: {
        sort: filter.filter.order || ""
      }
    });
  };

  this.findOne = function (query) {
    return _this3.post(_this3.name + "/findOne", {
      conditions: query.filter.where || {},
      projection: query.filter.fields || {}
    });
  };

  this.getHistory = function (_id) {
    return _this3.findOne({
      filter: {
        where: { _id: _id.replace("$", "") },
        fields: {
          history: true
        }
      }
    }).then(function (result) {
      return result ? result.history || [] : [];
    });
  };

  this.deleteById = function (_id) {
    return _this3.del(_this3.name + "/id/" + _id);
  };

  this.count = function (where) {
    return _this3.post(_this3.name + "/count", where || {});
  };

  this.customGet = function (path, params) {
    return _this3.get(_this3.name + "/" + path, params);
  };

  this.customPost = function (path, body) {
    return _this3.post(_this3.name + "/" + path, body);
  };

  this.customPut = function (path, body) {
    return _this3.put(_this3.name + "/" + path, body);
  };

  this.customPatch = function (path, body) {
    return _this3.patch(_this3.name + "/" + path, body);
  };

  this.customDelete = function (path) {
    return _this3.del(_this3.name + "/" + path);
  };
};